import { map as rxjsmap } from 'rxjs';



import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseServices } from './../../kuba.services';
import { HttpClient, HttpContext, HttpHeaderResponse } from '@angular/common/http';
import { SKIP_ERROR_TOAST } from '../../../shared/http-context-tokens';

@Injectable()
export class BusinessFeatureService {
    constructor(private http: HttpClient) {}

    getBusinessFeature(bid: any) {
        return this.http
            .get<HttpHeaderResponse>(
                environment.BASE_URL + '/business/' + bid + '/features',

            ).pipe(rxjsmap((response: HttpHeaderResponse) => {
                return response;
            }));
    }
    updateBusinessFeature(bid:any, data:any) {
        return this.http
            .put<HttpHeaderResponse>(
                environment.BASE_URL + '/business/' + bid + '/features',
                data,
                { context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
            ).pipe(rxjsmap((response: HttpHeaderResponse) => {
                return response;
            }));
    }
}
